import React from 'react';
import { Grid, Paper, Typography } from '@mui/material';
import VideoItem from './VideoItem';

const VideoList = ({videos, onVideoSelect}) => {

    const listOfVideos = videos.map((video, id)=><VideoItem onVideoSelect={onVideoSelect} key={id} video={video}/>);

    return (
        <Grid container>
            {listOfVideos}
        </Grid>
    )
}
export default VideoList
